import { fetchWithAuth } from '../utils/fetchWithAuth';

export const stockService = {
  async list({ serviceDeskId, signal } = {}) {
    const searchParams = new URLSearchParams();

    if (serviceDeskId !== undefined && serviceDeskId !== null && serviceDeskId !== '') {
      searchParams.set('serviceDeskId', String(serviceDeskId));
    }

    const queryString = searchParams.toString();
    const endpoint = queryString ? `/admin/stocks?${queryString}` : '/admin/stocks';
    const response = await fetchWithAuth(endpoint, { method: 'GET', signal });

    let body = {};
    try {
      body = await response.json();
    } catch (_) {
      body = {};
    }

    if (!response.ok || body?.success === false) {
      throw new Error(body?.error || `HTTP ${response.status}`);
    }

    return body?.data || [];
  },
};
